export default __webpack_public_path__ + "static/media/vitalik_poap_11.a96c65d4.svg";